import Container from "juis-components/Container.js";
import {createIcon} from "../../../bulma_components/Icon.js";
import BULMA_CSS_CLASSES from "../../../bulma_components/bulmaCssClasses.js";
import TextComponent from "../../../components/TextComponent.js";
import HTML from "../../../utils/HTML.js";

const getStockChangeCell = (change, product) => new Container(function () {
    if (change >= 0) {
        this.icon = createIcon("caret-up", BULMA_CSS_CLASSES.TYPOGRAPHY.HAS_TEXT_SUCCESS);
    } else {
        this.icon = createIcon("caret-down", BULMA_CSS_CLASSES.TYPOGRAPHY.HAS_TEXT_DANGER);
    }
    this.changeText = new TextComponent(Math.abs(change), HTML.SPAN);
    if (product?.unit) {
        this.unit = new TextComponent(" " + product.unit);
    }
});

export default getStockChangeCell;